import React from 'react'
import AdminStratorNav from './AdminStratorNav'
import GetAdminstraionForm from './GetAdministrationForm'

export default function Administrator() {
  return (
    <div>
<AdminStratorNav/>
<GetAdminstraionForm/>
    </div>
  )
}
